import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { changeOrderHref, type CustomerSessionInfo } from "@/lib/orderSummaryLinks";

interface ChangeOrderButtonProps {
  orgSlug: string;
  orderId: number;
  orderAccountId: number;
  /** The ordering page will open this order for changes (the order read's `editable`). */
  editable: boolean;
  /** This browser's customer session; null = not signed in. */
  session: CustomerSessionInfo | null;
  /** The session check is still in flight: no link yet, so a tap never takes a signed-in buyer to the sign-in card. */
  sessionPending: boolean;
}

// "Change this order" on the order summary (Jon, 2026-10-23): shown while the
// order can still be changed. See client/src/lib/orderSummaryLinks.ts.
export function ChangeOrderButton({ orgSlug, orderId, orderAccountId, editable, session, sessionPending }: ChangeOrderButtonProps) {
  if (!editable) return null;
  const content = (
    <>
      <Pencil className="h-4 w-4" />
      Change this order
    </>
  );
  if (sessionPending) {
    return (
      <Button disabled className="w-full sm:w-auto items-center gap-2" data-testid="button-change-order">
        {content}
      </Button>
    );
  }
  return (
    <Button asChild className="w-full sm:w-auto items-center gap-2">
      <a href={changeOrderHref({ orgSlug, orderId, orderAccountId, session })} data-testid="button-change-order">
        {content}
      </a>
    </Button>
  );
}
